type PropsType = {
  type: "original" | "medium" | "thumb";
  image: CompanyNewsImage;
  alt?: string;
};

export const NewsImage = ({ type, image, alt }: PropsType) => {
  if (!image[type]) {
    return null;
  }

  return <img src={image[type]} alt={alt || ""} className={`TT-news-jumbotron-image rounded`} />;
};
